/**
 * 性別選択サブステップ
 */
import I18n from "features/shared/i18n";
import { CreatePlayerState, PlayerGender } from "../../types";

interface GenderStepProps {
  state: CreatePlayerState;
  updateState: (updates: Partial<CreatePlayerState>) => void;
}

const GENDER_OPTIONS: {
  key: PlayerGender;
  labelKey: string;
  icon: string;
  bgColor: string;
}[] = [
  {
    key: PlayerGender.MALE,
    labelKey: "MSG_GENDER_MALE_BY_PARENT",
    icon: "man",
    bgColor: "bg-blue-100",
  },
  {
    key: PlayerGender.FEMALE,
    labelKey: "MSG_GENDER_FEMALE_BY_PARENT",
    icon: "woman",
    bgColor: "bg-red-100",
  },
];

export const GenderStep = ({ state, updateState }: GenderStepProps) => {
  const handleSelect = (gender: PlayerGender) => {
    updateState({ gender });
  };

  return (
    <div className="flex-col-el items-center justify-center w-full h-full">
      {/* タイトル */}
      <div className="flex-col-el flex-center mb-8">
        <p className="text-body text-textcolor-black text-[24px]">
          {I18n.t("MSG_CREATE_USER_TITLE_GENDER_BY_PARENT")}
        </p>
      </div>

      {/* 性別選択タイル */}
      <div className="flex-row-el flex-center gap-6">
        {GENDER_OPTIONS.map((option) => (
          <div
            key={option.key}
            onClick={() => handleSelect(option.key)}
            className={`flex-col-el items-center justify-center w-[200px] h-[200px] rounded-[8px] cursor-pointer select-none hover:opacity-90 transition-all ${state.gender === option.key ? option.bgColor : "bg-gray2-40"}`}
          >
            <span className="material-symbols-outlined !text-6xl text-white mb-3">
              {option.icon}
            </span>
            <p className="text-body text-[20px] text-white text-center">
              {I18n.t(option.labelKey)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
